module.exports = __webpack_public_path__ + "img/ry1.47818547.jpeg";